module.exports = __webpack_public_path__ + "img/cloud-necklace.186e6afb.jpg";